import tools from './tools.js'
/**
 * 解析时间为字符串
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  return tools.parseTime(time, cFormat)
}
/**
 * 数值（秒）转时间
 * @param {number} sec
 */
export function secondsToTime(sec) {
  return tools.secondsToTime(sec)
}
/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num.toString()
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function distanceFormatter(num, digits = 2) {
  const numM = num / 100
  let result = num.toString()
  if (numM > 100 * 1e3) {
    result = '>100km'
  } else if (numM < 10) {
    result = '<10m'
  } else if (numM >= 10 && numM < 1e3) {
    result =
      numM.toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + 'm'
  } else if (numM >= 1e3 && numM <= 100 * 1e3) {
    result =
      (numM / 1e3).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') +
      'km'
  }

  return result
}
/**
   * 分转元
   * @param {number} num
   */
export function fenToYuan(num, len = 2) {
  return tools.fenToYuan(num, len)
}



// WEBPACK FOOTER //
// ./src/utils/filters.js